import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'

export function useGetEmployerStripePrices (employerId: string) {
  return useQuery<string[], GrapeAPIErrorType>({
    queryKey: ['stripe-prices', employerId],
    queryFn: async () => {
      if (!employerId) {
        return []
      }

      const response = await fetchWithHeaders(`/api/web/admin/stripe/prices/${employerId}`)
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
  })
}
